import Vue from "vue";

export default {
	search({dispatch}, filter) {
		return dispatch('list', filter)
	},
	list({}, filter) {
		let type = (filter.clinic_type)? [filter.clinic_type] : ''

		return Vue.api.post('clinic/list', {
			name: filter.name || '',
			own_type: filter.own_type || '',
			clinic_type_ids: type || '',
			city: filter.city || '',
			type: filter.type || '',
			region: filter.region || '',
			metro: filter.metro || '',
			per_page: filter.per_page || 10,
			current_page: filter.current_page || 1
		})
	},
	create({}, data) {
		return Vue.api.post('clinic/', data)
	},
	get({}, id) {
		return Vue.api.get('clinic/' + id)
	},
	update({dispatch}, data) {
		if (!data._id) {
			return dispatch('create', data)
		}

		return Vue.api.put('clinic/' + data._id, data)
	},
	delete({}, id) {
		return Vue.api.delete('clinic/' + id)
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/clinic/actions.js